import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <>
      <div>
        <div className="flex h-screen items-center justify-center">
          <div className="text-center">
            <h1 className="mb-4 text-4xl font-bold text-gray-900 dark:text-white">
              404
            </h1>
            <p className="mb-4 text-gray-500 dark:text-gray-400">
              Something&apos;s missing.
            </p>
          </div>          
        </div>
      </div>
    </>
  );
}
